import { createAction } from "redux-actions";

import { createAsyncAction } from "../helpers";

export const getPointsAdditionalListAsyncAction = createAsyncAction(
	"GET_POINTS_ADDITIONAL_LIST_REQUEST",
	"GET_POINTS_ADDITIONAL_LIST_SUCCESS",
	"GET_POINTS_ADDITIONAL_LIST_FAILURE",
	"GET_POINTS_ADDITIONAL_LIST_CANCEL"
);

export const postPointsAdditionalAsyncAction = createAsyncAction(
	"POST_POINTS_ADDITIONAL_CREATE_REQUEST",
	"POST_POINTS_ADDITIONAL_CREATE_SUCCESS",
	"POST_POINTS_ADDITIONAL_CREATE_FAILURE",
	"POST_POINTS_ADDITIONAL_CREATE_CANCEL"
);

export const updatePointsAdditionalAsyncAction = createAsyncAction(
	"PUT_POINTS_ADDITIONAL_UPDATE_REQUEST",
	"PUT_POINTS_ADDITIONAL_UPDATE_SUCCESS",
	"PUT_POINTS_ADDITIONAL_UPDATE_FAILURE",
	"PUT_POINTS_ADDITIONAL_UPDATE_CANCEL"
);

export const deletePointsAdditionalByIdAsyncAction = createAsyncAction(
	"DELETE_POINTS_ADDITIONAL_REQUEST",
	"DELETE_POINTS_ADDITIONAL_SUCCESS",
	"DELETE_POINTS_ADDITIONAL_FAILURE",
	"DELETE_POINTS_ADDITIONAL_CANCEL"
);

export const getPointsAdditionalAsyncAction = createAsyncAction(
	"GET_POINTS_ADDITIONAL_CARD_REQUEST",
	"GET_POINTS_ADDITIONAL_CARD_SUCCESS",
	"GET_POINTS_ADDITIONAL_CARD_FAILURE",
	"GET_POINTS_ADDITIONAL_CARD_CANCEL"
);

export const resetAction = createAction("POINTS_RESET_ACTIONS");
